import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild,} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {
  AvailabilityUpdateInfo,
  Edition,
  GetItRequest,
  HoldRequest,
  MaterialTab,
} from '../../../../../models/entity';
import {GroupedLocationInfo, LocationAvailabilityStatus} from 'search/models/search-results';
import {ConfigurationLoader} from 'shared/configuration-loader';
import {VendorLogo} from 'shared/models/configuration';
import {ResourceSharingOffer} from '../../../../../models/rapido-offer';
import {Store} from '@ngrx/store';
import {tryToGetItTabRapido} from '../../../../../actions/entity.actions';
import {RapidoOffersService} from '../../../../../../services/rapido-offers.service';
import {FullEntityState} from '../../../../../reducers/full-entity.reducer';

@Component({
  selector: 'app-rollup-tabs-content-rapido',
  templateUrl: './rollup-tabs-content-rapido.component.html',
  styleUrls: ['./rollup-tabs-content-rapido.component.scss'],
})
export class RollupTabsContentRapidoComponent implements OnInit, OnDestroy {
  @Input() public materialTab: MaterialTab;
  @Input() public availabilityUpdateInfo: AvailabilityUpdateInfo;
  @Input() public queryParams = {};
  @Input() public fgId: string;
  @Input() public fgTitle: string;
  @Input() public author: string;
  @Input() public publicationYear: string;
  @Input() public publisher: string;
  @Input() public specificEdition: string;
  @Input() public isbn: string;
  @Input() public ariaDescribedBy = '';
  @Input() public language: string;
  @Input() public hasEcontentIssues: boolean;
  @Input() public tabName: string;
  @Input() public resourceId: string;
  @Output() public getIt$ = new EventEmitter<{ item: GetItRequest }>(true);
  @Output() public placeHold$ = new EventEmitter<{ item: HoldRequest }>(true);
  @Output() public checkLocationAndEditionInfo$ = new EventEmitter<{ resourceId: string }>(true);
  @Input() public edition: Edition;

  public readonly subscriptions = new Subscription();
  public instanceIds: string[];
  public locations: GroupedLocationInfo[];
  public vendorsLogo: { [key: string]: string };
  public nonIntegratedLogo: { [key: string]: VendorLogo }
  public recordId: string;
  public offer: ResourceSharingOffer;
  public offerError: boolean = false;
  public loading: boolean = false;

  @ViewChild('getItButton', {read: ElementRef}) public getItButton: ElementRef;
  isPatronAuthorized: boolean;

  constructor(
    private configLoader: ConfigurationLoader,
    public router: Router,
    private readonly store: Store<FullEntityState>,
    private readonly offersService: RapidoOffersService
  ) {
  }

  public ngOnInit() {
    this.recordId = this.materialTab.recordIds?.[0];
    this.vendorsLogo = this.configLoader.vendorsLogo;
    this.nonIntegratedLogo = this.configLoader.nonIntegratedConnectionsLogoMapping;
    this.instanceIds = this.materialTab.editions?.map((instance) => instance.id);
    const locationMap: { [key: string]: GroupedLocationInfo } = {};

    this.materialTab.locations?.forEach(({label, code, availabilityStatus}) => {
      const current: GroupedLocationInfo = locationMap[label] || {label, codes: [], availabilityStatus};
      current.codes.push(code);
      locationMap[label] = current;
      if (availabilityStatus === LocationAvailabilityStatus.Available) {
        locationMap[label].availabilityStatus = availabilityStatus;
      }
    }, locationMap);
    this.locations = Object.values(locationMap);
  }

  public onLocationAndEditionInfoClick() {
    const params = {...this.queryParams, rapido: true};
    this.router.navigate(['/search', 'card'], {queryParams: params});
    this.checkLocationAndEditionInfo$.emit();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onGetIt(event: Event) {
    event.stopPropagation();
    const item = {
      title: this.fgTitle,
      id: this.materialTab.editions[0].id,
      recordId: this.recordId,
      tabName: this.materialTab.name,
      author: this.author,
      publicationYear: this.publicationYear,
      publisher: this.publisher,
      specificEdition: this.specificEdition,
      isbn: this.isbn,
    };

    this.store.dispatch(
      tryToGetItTabRapido({
        cardInfo:item
      })
    );
  }
}
